import { NpcService } from "../services/NpcService";

export class NpcComponent extends HTMLElement {
    private _NpcService: NpcService = new NpcService();

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    position: fixed;
                    top: 10px;
                    right: 10px;
                    display: block;
                    padding: 10px;
                    font-family: Arial, sans-serif;
                    z-index: 1000;
                    width: 250px; /* Set a width for the container */
                }
                .npc-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px; /* Space between elements */
                }
                .feedback {
                    padding: 12px 18px;
                    background: #7f6ed7;
                    color: white;
                    border-radius: 8px;
                    opacity: 0;
                    transform: translateY(-20px);
                    transition: all 0.3s ease;
                    pointer-events: none;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    width: 100%;
                    text-align: center;
                }
                .feedback.show {
                    opacity: 1;
                    transform: translateY(0);
                }
                .npc-submit {
                    background-color: #7f6ed7;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    cursor: pointer;
                    border-radius: 6px;
                    transition: background-color 0.2s;
                    width: 100%;
                }
                .npc-submit:hover {
                    background-color: #6a5acd;
                }
                .npc-input {
                    padding: 8px;
                    width: 100%; /* Full width */
                    border: 2px solid #ddd;
                    border-radius: 6px;
                    font-size: 14px;
                }
                .npc-input:focus {
                    outline: none;
                    border-color: #7f6ed7;
                }
            </style>
            <div class="npc-container">
                <input type="text" class="npc-input" placeholder="Voer de geheime code in..." />
                <button class="npc-submit">Verify Code</button>
                <div class="feedback"></div>
            </div>
        `;

        const submitButton: HTMLButtonElement = this.shadowRoot.querySelector(".npc-submit")!;
        const inputElement: HTMLInputElement = this.shadowRoot.querySelector(".npc-input") as HTMLInputElement;
        const feedbackDiv: HTMLDivElement = this.shadowRoot.querySelector(".feedback") as HTMLDivElement;

        submitButton.addEventListener("click", async () => {
            if (!inputElement.value.trim()) {
                this.showFeedback("🔑 Voer een code in", feedbackDiv);
                return;
            }

            const response: { message: string; correct: boolean } = await this._NpcService.checkCode(inputElement.value.trim());
            this.showFeedback(response.message, feedbackDiv);

            if (response.correct) {
                inputElement.value = "";
            }
        });
    }

    private showFeedback(text: string, element: HTMLDivElement): void {
        element.textContent = text;
        element.classList.add("show");
        setTimeout(() => {
            element.classList.remove("show");
        }, 15000);
    }
}
